import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { UserSessionService } from './usersession.service';
import { AuthenticationService } from './authentication.service';
import { AlertService } from './alert.service';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import swal from 'sweetalert2';
import { UserService } from './user.service';
import { PopupService } from './popup.service';

@Injectable()

export class HttpInterceptorService implements HttpInterceptor {

    private baseUrl = environment.apiBaseUrl;

    constructor(
        private router: Router,
        private sessionService: UserSessionService,
        private authService: AuthenticationService,
        private alertService: AlertService,
        private userService: UserService,
        public translate: TranslateService,
        public popupService: PopupService) { window.onbeforeunload = function () { return "Your work will be lost."; }; }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        window.onbeforeunload = function () { return "Your work will be lost."; };
        const authToken = this.sessionService.authToken();
        const isTokenEndPoint = request.url.match('/admin/otp/verify');
        const isversion = request.url.match('api/version');
        if (isTokenEndPoint === null && authToken && isversion == null) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authToken}`,
                }
            });
        }

        return next.handle(request).pipe(tap((event: any) => {
        }, (error: any) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    this.router.navigate(['/auth/login']);
                    this.authService.logOut();
                    this.popupService.error("Session Expired")
                } else if (error.status === 422) {
                    this.popupService.error(error.error.email[0]);
                }
                else if (error.status === 403) {
                    this.popupService.error(error.error.error);
                } else {
                    this.broadcastFriendlyErrorMessage(error);
                }
            }
            return throwError(error);
        })) as any;
    }

    broadcastFriendlyErrorMessage(rejection) {
        let msg = '';
        if (rejection.status === 0 && (rejection.statusText === '' || rejection.statusText === 'Unknown Error')) {
            this.popupService.error('Unable to connect to the server, please try again in a couple of seconds.');
        } else if (rejection.status == 429) {
            this.popupService.error('You are allowed to send only one OTP every 3 minutes, so try after sometime.');
        } else if (rejection.status === 400) {
            if (rejection.error) {
                msg = rejection.error.htmlFormattedFailures
            }
            this.popupService.error(msg);
        } else if (rejection.status === 404) {
            if (rejection.message) {
                this.popupService.error(rejection.message);
            }
        } else if (rejection.status === 500) {
            if (rejection.error && rejection.error.Message) {
            } else if (rejection.message) {
            }
        } else if (rejection.status === 409) {
            if (rejection.error && rejection.error.Message) {
                this.popupService.error(rejection.error.Message);
            } else if (rejection.message) {
                const message = rejection.message;
                this.popupService.error(message);
            }
        } else if (rejection.responseStatus === 401) {
            this.authService.logOut();
            this.router.navigate(['/login']);
        } else if (rejection.responseStatus === 0) {
            this.popupService.error('Error occured, while uploading file');
        } else if (rejection.responseStatus === 400) {
            if (rejection.response) {
                msg = rejection.response;
            }
            this.popupService.error(msg);
        }
    }
}
